import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip, Box, Typography } from '@mui/material';
import { Language as LanguageIcon, Check } from '@mui/icons-material';
import { SUPPORTED_LANGUAGES } from '../i18n';
import api from '../services/api';

const LanguageSwitcher = ({ color = 'inherit', variant = 'icon' }) => {
  const { i18n, t } = useTranslation();
  const { user } = useSelector((s) => s.auth || {});
  const [anchorEl, setAnchorEl] = useState(null);

  const current = SUPPORTED_LANGUAGES.find((l) => l.code === i18n.language) || SUPPORTED_LANGUAGES[0];

  const choose = async (code) => {
    setAnchorEl(null);
    if (code === i18n.language) return;
    i18n.changeLanguage(code);
    localStorage.setItem('osesg_lang', code);
    if (user?._id) {
      try { await api.put('/users/me/language', { language: code }); } catch (_) {}
    }
  };

  return (
    <>
      <Tooltip title={t('choose_language')}>
        {variant === 'icon' ? (
          <IconButton color={color} onClick={(e) => setAnchorEl(e.currentTarget)} size="small">
            <LanguageIcon />
            <Typography variant="caption" sx={{ ml: 0.5, textTransform: 'uppercase' }}>
              {current.code}
            </Typography>
          </IconButton>
        ) : (
          <Box
            onClick={(e) => setAnchorEl(e.currentTarget)}
            sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 1, px: 1, py: 0.5 }}
          >
            <LanguageIcon fontSize="small" />
            <Typography variant="body2">{current.nativeLabel}</Typography>
          </Box>
        )}
      </Tooltip>
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={() => setAnchorEl(null)}>
        {SUPPORTED_LANGUAGES.map((l) => (
          <MenuItem key={l.code} onClick={() => choose(l.code)} selected={i18n.language === l.code}>
            <ListItemIcon sx={{ minWidth: 32, fontSize: 20 }}>{l.flag}</ListItemIcon>
            <ListItemText
              primary={l.nativeLabel}
              secondary={l.label}
              primaryTypographyProps={{ fontWeight: i18n.language === l.code ? 700 : 400 }}
            />
            {i18n.language === l.code && <Check fontSize="small" color="primary" />}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSwitcher;
